import * as React from "react"
import cx from "classnames"
import { StaticImage } from "gatsby-plugin-image"
import { CSSTransition } from "react-transition-group"

import Container from "@components/elements/container"
import Link from "@components/elements/link"
import Cta from "@components/elements/cta"
import SocialLinks from "@components/elements/socialLinks"

import { internalRoutes } from "@data/routes"

import LogoIcon from "@images/logo-icon-dark.inline.svg"

import styles from "./navigation.module.scss"

const DATA_NAVIGATION_ITEMS = [
  {
    title: "Solutions",
    url: internalRoutes.SOLUTIONS,
  },
  {
    title: "R+D Roadmap",
    url: internalRoutes.ROADMAP,
  },
  {
    title: "Technology",
    url: internalRoutes.TECHNOLOGY,
  },
  {
    title: "Decarbonization",
    url: internalRoutes.DECARBONIZATION,
  },
  {
    title: "Resources",
    url: internalRoutes.RESOURCES,
  },
  {
    title: "About",
    url: internalRoutes.ABOUT,
    isSecondary: true,
  },
  {
    title: "News",
    url: internalRoutes.NEWS,
    isSecondary: true,
  },
  {
    title: "Careers",
    url: internalRoutes.CAREERS,
    isSecondary: true,
  },
  {
    title: "Contact",
    url: internalRoutes.CONTACT,
    isSecondary: true,
  },
]

const Navigation = ({ close, isOpen }) => {
  return (
    <>
      <CSSTransition in={isOpen} timeout={400} classNames="show" unmountOnExit>
        <>
          <nav className={styles.navigation}>
            <Container className={styles.navigationContainer}>
              <ul className={styles.navigationList}>
                {DATA_NAVIGATION_ITEMS.map(navItem => (
                  <li
                    className={cx(styles.navigationItem, {
                      [styles.isSecondary]: navItem.isSecondary,
                    })}
                    key={navItem.title}
                  >
                    <Link
                      className={styles.navigationLink}
                      url={navItem.url}
                      activeClassName={styles.isCurrent}
                      onClick={close}
                    >
                      {navItem.title}
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                className={styles.homeLink}
                url={internalRoutes.HOME}
                onClick={close}
              >
                <LogoIcon />
              </Link>
              <div className={styles.contact}>
                <p className={styles.contactTitle}>Syzygy plasmonics</p>
                <p>
                  3250 South Sam Houston Parkway East,
                  <br />
                  Houston, TX 77047, US
                  <br />
                  <br />
                  +1 713.347.1330
                </p>
                <a href="mailto:info@plasmonics.tech">info@plasmonics.tech</a>
              </div>
              <div className={styles.cta}>
                <Cta
                  text="Join our newsletter"
                  url={`${internalRoutes.CONTACT}#newsletter`}
                  variant="link"
                  color="light"
                  onClick={close}
                />
                <SocialLinks className={styles.socialLinks} />
              </div>
            </Container>
          </nav>

          <button
            className={styles.overlay}
            aria-label="Close Navigation"
            onClick={close}
          ></button>
          <StaticImage
            className={styles.background}
            quality={100}
            src="../../images/bg-gradient-1.jpg"
            placeholder="dominantColor"
            alt=""
          />
        </>
      </CSSTransition>
    </>
  )
}

export default Navigation
